var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can(_vm.I.MODIFY_ENROLLMENT))?_c('button',{staticClass:"prime-button button-secondary prime-action-button-container",class:{
    'button-pending': _vm.isLoading
  },attrs:{"id":_vm.buttonID},on:{"click":_vm.handleButtonClick}},[_c('EnrollmentToolText',{attrs:{"status":_vm.enrollmentStatus}},[_vm._v(_vm._s(_vm.buttonText))]),_c('ion-spinner',{attrs:{"name":"dots","duration":"1200"}})],1):_c('EnrollmentToolText',{attrs:{"status":_vm.enrollmentStatus}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }